export default "__VITE_ASSET__6398995c__"